import React, { useEffect, useState } from 'react'
import CollectService from '../../services/api/CollectService'
import ProgressionContent from './ProgressionContent'
import { todayIso } from '../../utils/dateHelpers'

const ERROR_MESSAGE = 'Une erreur est survenue lors du chargement.'
const INITIAL_DATA = { variables: [], draftStartingAt: null }

const Progression = ({ collectId, draftId, dateRangeMin, dateRangeMax }) => {
  const [collectData, setCollectData] = useState(INITIAL_DATA)
  const [fetchError, setFetchError] = useState(null)

  useEffect(() => {
    let cancelled = false
    CollectService.getCollectData(collectId)
      .then(data => {
        if (cancelled)
          return
        const next = { variables: data.variables || [], draftStartingAt: null }
        if (draftId) {
          const draft = data.drafts.find(item => item.id === draftId)
          if (!draft || !draft.starting_at) {
            setFetchError(ERROR_MESSAGE)
            return
          }
          next.draftStartingAt = draft.starting_at
        }
        setCollectData(next)
      })
      .catch(() => {
        if (!cancelled)
          setFetchError(ERROR_MESSAGE)
      })
    return () => { cancelled = true }
  }, [collectId, draftId])

  if (fetchError) {
    return (
      <div
        className={'tw:relative tw:m-4 tw:px-5 tw:py-3 tw:border tw:border-solid '
          + 'tw:rounded-md! tw:bg-ds-danger-lowest tw:text-ds-danger'}
      >
        {fetchError}
      </div>
    )
  }

  const resolvedMin = dateRangeMin || collectData.draftStartingAt?.slice(0, 10)
  const resolvedMax = dateRangeMax || todayIso()

  return (
    <ProgressionContent
      collectId={collectId}
      dateRangeMax={resolvedMax}
      dateRangeMin={resolvedMin}
      draftId={draftId}
      variables={collectData.variables}
    />
  )
}

export default Progression
